import { apps } from '@/data/apps'
import { Apps, type IApp } from '@/dtos'
import { Product } from 'BrokerTsLib/src/enums'
import React, { useEffect, useState } from 'react'
import type { Environment } from '../appSettings'
import { AppSettings } from '../appSettings'

interface IAppContext {
  environment: Environment
  product: Product | null
  setProduct: React.Dispatch<React.SetStateAction<Product | null>>

  app: Apps | null
  currentApp: IApp | null

  /** Current non-null App or App which was used last time or default app. */
  lastApp: IApp
  setLastApp: React.Dispatch<React.SetStateAction<Apps | null>>
  lastProduct?: Product | null
}

interface IAppProvider {
  children?: React.ReactNode
  app: Apps | null
}

export const AppContext = React.createContext<IAppContext | null>(null)

export const AppProvider = ({ app, children }: IAppProvider) => {
  const [product, setProduct] = useState<Product | null>(getProduct(app))
  const [currentApp, setCurrentApp] = useState<Apps | null>(app)
  const [lastApp, setLastApp] = useState<Apps | null>(app ? app : sessionStorage.getItem('app') ? Number.parseInt(sessionStorage.getItem('app')!) as Apps : null)

  useEffect(() => {
    setCurrentApp(app)
    setProduct(getProduct(app))

    if (app) {
      setLastApp(app)
      sessionStorage.setItem('app', JSON.stringify(app))
    }
  }, [app])

  const currentAppValue = apps.find(a => a.app === currentApp)!
  const lastAppValue = apps.find(a => a.app === lastApp)!

  return (
    <AppContext.Provider value={{
      environment: AppSettings.enviroment,
      product,
      app: currentApp,
      setProduct,
      currentApp: currentAppValue,
      lastApp: lastAppValue,
      setLastApp: setLastApp,
      lastProduct: product ?? getProduct(lastApp)
    }}>
      {children && children}
    </AppContext.Provider>
  )
}

export const getProduct = (app: Apps | null) => {
  switch (app) {
    case Apps.leasing:
    case Apps.leasingSimplifiedWizard:
      return Product.VehicleLeasingInsurance
    case Apps.property:
      return Product.PropertyInsurance
    case Apps.travel:
      return Product.TravelInsurance
    case Apps.fleet:
      return Product.FleetInsurance
    case Apps.extra:
    case Apps.shortInsurance:
    case Apps.vehicle:
    case Apps.publicPoleas:
      return Product.VehicleInsurance
    default: return null
  }
}